var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 223.7 269.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.3,163.6c-16.1-16.1-16.5-42.3-1.2-58.9l2.4-2.4c14.8-13.8,37.9-13.8,52.6,0.2l43.6,43.6      c5.9,5.9,15.5,5.9,21.4,0l0,0c5.8-5.8,5.9-15.2,0.2-21.2L117,78.6c-13.2-13.2-13.2-34.7,0-47.9l0,0l4.6-4.6      c5.1-5.1,5.1-13.3,0-18.3v0c-4.9-4.9-12.8-5-17.9-0.4l0,0l-0.4,0.4c0,0,0,0,0,0L75.6,35.4l0,0L23,88c-25,25-25,66,0,91l43.8,43.8      c5.1,5.1,13.3,5.1,18.3,0c5.1-5.1,5.1-13.3,0-18.3L44.3,163.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.8,89l-16.1-16.1L157,45.3c-5.1-5.1-13.3-5.1-18.3,0c-5.1,5.1-5.1,13.3,0,18.3l40.8,40.8      c14.9,14.9,16.4,38.2,4.6,54.8c-1.3,1.9-2.8,3.7-4.5,5.4h0c-15.2,15.2-39.8,15.2-54.9,0l0,0L83,122.9c-5.9-5.9-15.5-5.9-21.4,0      c-5.8,5.8-5.9,15.2-0.2,21.2l0,0l44.4,44.4l0,0c13.7,13.7,13.7,36,0,49.8l-3.6,3.6c-5.1,5.1-5.1,13.3,0,18.3l0,0      c5,5,13.1,5.1,18.1,0.2l0,0l0.2-0.2l27.6-27.6l0,0l52.6-52.6C225.8,155,225.8,114,200.8,89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwine);
export default __webpack_public_path__ + "static/media/twine.82988cd9fb6477cf314e697a8f466170.svg";
export { ForwardRef as ReactComponent };